import React, { useEffect, useState } from "react";
import { Team } from "../../../../types/teamTypes"; // Assicurati che il path sia corretto
import { searchTeam } from "../../../../queries/teamQueries"; // Funzione ipotetica per i team
import CustomAutoComplete from "../CustomAutoComplete";

interface TeamSearchProps {
    label?: string;
    value: Team | Team[] | null;
    onChange: (value: Team | Team[]) => void;
    freeSolo: boolean;
    disabled?: boolean;
    multiple?: boolean;
}

const TeamSearch: React.FC<TeamSearchProps> = ({
                                                   value,
                                                   label = "Find Team",
                                                   onChange,
                                                   freeSolo,
                                                   disabled = false,
                                                   multiple = false
                                               }) => {
    const [query, setQuery] = useState<string>("");
    const [teamOptions, setTeamOptions] = useState<Team[]>([]);

    const onQueryChange = (newQuery: string) => {
        setQuery(newQuery);
    };

    useEffect(() => {
        const fetchOptions = async () => {

            try {
                const teams = await searchTeam(query);
                setTeamOptions(teams);
            } catch (error) {
                console.error("Errore durante la ricerca dei team:", error);
                setTeamOptions([]);
            }
        };

        const delayDebounceFn = setTimeout(() => {
            fetchOptions();
        }, 500);

        return () => clearTimeout(delayDebounceFn);
    }, [query]);

    return (
        <CustomAutoComplete
            label={label}
            options={teamOptions}
            value={value}
            onChange={(_: any, newValue: any) => onChange(newValue)}
            customAutocomplete={false}
            textFieldValue={query || ''}
            textFieldOnChange={(value: string) => onQueryChange(value)}
            multiple={multiple}
            labelField={'value'}
            valueField={'id'}
            freeSolo={freeSolo}
            disabled={disabled}
        />
    );
};

export default TeamSearch;